import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { WHATSAPP_URL } from "../data/story";
type CtaButtonProps = {
  label: string;
  size?: "md" | "lg";
  fullWidthMobile?: boolean;
};
export function CtaButton({
  label,
  size = "lg",
  fullWidthMobile = true
}: CtaButtonProps) {
  const sizing = size === "lg" ? `${fullWidthMobile ? "w-full sm:w-auto" : ""} px-5 py-4 text-sm sm:px-7 sm:text-base md:text-lg` : "px-4 py-2.5 text-sm";
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full bg-accent font-display font-extrabold uppercase tracking-tight text-ink transition-[transform,background-color] duration-150 ease-out hover:bg-[#E4FF70] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink ${sizing}`} data-id="element-15" data-mp="qihahroowlmf">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden data-id="element-16" data-mp="35x5y7jbaqy4l" />
    </a>;
}